module.exports = __webpack_public_path__ + "img/pain-spot-10.6215cac3.svg";